import { createContext, useEffect, useState } from "react";
import { getErrorMessageFromError } from "../../components/ErrorMessage";
import { useApp } from "../../hooks/useApp";
import { CompanyDto } from "../../model/CompanyDto";
import { SVCompaniesRequest, SVCompanyDelete, SVCompanySaveRequest, SVCompanyUpdatedRequest } from "../../services/companies/CompaniesService";

const CompaniesDataContext = createContext();

const CompaniesDataContextProvider = ({ children }) => {
    const [listCompanies, setListCompanies] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [companyIdToDelete, setCompanyIdToDelete] = useState(0);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const { setSuccessMsg,
        setErrorMsg,
        setLoading,
        messageUser,
        loading,
        authenticate,
        authInfo,
        isAdmin,
    } = useApp();
    const [isFirstRenderRowsPerPage, setIsFirstRenderRowsPerPage] = useState(true);
    const [page, setPage] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);        
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    useEffect(() => {
        if(authenticate,authInfo)
            setTimeout(
                () => loadCompanies(), 
                100
            );
    },[page]);

    useEffect(() => {
        if(isFirstRenderRowsPerPage)
            setIsFirstRenderRowsPerPage(false);
        else{
            if(page == 0)
                setTimeout(
                    () => loadCompanies(), 
                    100
                );
            else
                setPage(0);
        }
    },[rowsPerPage]);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedCompany(null)
    };

    const onClickActionEditButton = (params) => {
        setSelectedCompany(params.row);
        handleOpenModal()
    };

    const handleFormSubmit = async (values) => {
        try {
            const input = {
                ...values
            };
            setLoading(true)
            if (values.id) {
                await SVCompanyUpdatedRequest(input);
                setSuccessMsg("Editado con éxito");

            } else {
                await SVCompanySaveRequest(input);
                setSuccessMsg("Creado con éxito")
            }
            loadCompanies();
            setLoading(false);
            handleCloseModal();
        } catch (error) {
            let errorMessage = getErrorMessageFromError(error);
            if (!errorMessage) {
                errorMessage = "Error desconocido al procesar la solicitud";
            }
            setErrorMsg(errorMessage);
            setLoading(false);
        }
    }

    const loadCompanies = async () => {
        // console.log("desde contexts");
        try {
            setLoading(true);
            let responseCompaniesList = await SVCompaniesRequest(authInfo.id, authInfo.userRole.id, page, rowsPerPage);
            setTotalItems(responseCompaniesList.totalElements);
            const companies = responseCompaniesList.content.map(companyData => {
                return new CompanyDto(
                    companyData.factor_id,
                    companyData.name
                );
            })
            setListCompanies(companies)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            const errorMessage = getErrorMessageFromError(error);
            setErrorMsg(errorMessage)
            setLoading(false);
        }
    }

    const openDeleteConfirmation = (companyId) => {
        setCompanyIdToDelete(companyId);
        setShowDeleteConfirmation(true);
    };

    const closeDeleteConfirmation = () => {
        setCompanyIdToDelete(null);
        setShowDeleteConfirmation(false);
    };

    const handleDeleteConfirmed = async () => {
        closeDeleteConfirmation();
        if (companyIdToDelete) {
            await handleDelete(companyIdToDelete);
        }
    };

    const handleDelete = async (companyId) => {
        try {
            setLoading(true)
            await SVCompanyDelete(companyId);
            setSuccessMsg("Eliminado con éxito")
            loadCompanies();
            setLoading(false)
        } catch (error) {
            let errorMessage = getErrorMessageFromError(error);
            if (!errorMessage) {
                errorMessage = "Error desconocido al procesar la solicitud";
            }
            setErrorMsg(errorMessage);
            setLoading(false);
        }
    };

    return (
        <CompaniesDataContext.Provider value={{
            listCompanies,
            loadCompanies,
            loading,
            messageUser,
            handleOpenModal,
            handleCloseModal,
            isModalOpen,
            onClickActionEditButton,
            setSelectedCompany,
            selectedCompany,
            showDeleteConfirmation,
            openDeleteConfirmation,
            closeDeleteConfirmation,
            handleDeleteConfirmed,
            handleFormSubmit,
            handleDelete,
            page, 
            setPage,
            rowsPerPage, 
            handleChangePage,
            handleChangeRowsPerPage,
            totalItems
        }}>
            {children}
        </CompaniesDataContext.Provider>
    )
}

export { CompaniesDataContext, CompaniesDataContextProvider };
